export default "__VITE_ASSET__r5IEJY7Q__"